import React from "react";
import { useTranslation } from "react-i18next";

import { deleteOauthClient } from "@admin/api/client";
import { showErrorToast, showSuccessToast } from "@shared/toasts/Toasts";

export const useDeleteOauthClient = () => {
    const [isLoading, setIsLoading] = React.useState(false);

    const { t } = useTranslation(["pages"]);

    const onMutate = (clientId: string, onSuccess: (clientId: string) => void) => {
        setIsLoading(true);

        void deleteOauthClient(clientId)
            .then(() => {
                showSuccessToast(t("pages:adminOauthClientsPage.toast.oauthClientDeletedSuccess"));
                onSuccess(clientId);
            })
            .catch((error) => {
                const err = error as Error;
                showErrorToast(err?.message || t("pages:adminOauthClientsPage.toast.oauthClientDeleteError"));
            })
            .finally(() => setIsLoading(false));
    };

    return { isLoading, onMutate };
};
